import { render } from "./StarArticleContent.vue?vue&type=template&id=6dbb0c2b&scoped=true&ts=true"
import script from "./StarArticleContent.vue?vue&type=script&lang=ts"
export * from "./StarArticleContent.vue?vue&type=script&lang=ts"

import "./StarArticleContent.vue?vue&type=style&index=0&id=6dbb0c2b&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbb0c2b"]])

export default __exports__